import React from "react";
import ReactGA from "react-ga4";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import * as Sentry from "@sentry/react";
import "./index.css";

// import "./assets/scss/index.scss";
// import "react-app-polyfill/ie11";
// import "react-app-polyfill/stable";

if (import.meta.env.VITE_NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://3162d99f868370d835fa81db3168c674@o4509037329252352.ingest.de.sentry.io/4509037331021904",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_NODE_ENV,
  });

  const { VITE_GOOGLE_ANALYTICS_UA } = import.meta.env;
  ReactGA.initialize(VITE_GOOGLE_ANALYTICS_UA);
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);
root.render(<App />);
